export default __webpack_public_path__ + "static/media/truck.b973a15e.png";